import React from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../components/Form/Field'
import CountryOfOperationField from '../../../CountryOfOperationField'

import { getSroiCurrencySymbol } from '../../../../../hooks'

import { TOTAL_ACTIVITY_HOURS, COUNTRY_ID, TOTAL_INVESTMENT, TITLE } from '../../../../fields'

import useDrawerFormClasses from '../../../../../../../../styles/common/drawerForms'

const GeneralInputsSection = ({ formik }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormClasses()

  const { values } = formik

  const countryOfOperation = values[COUNTRY_ID]

  const currencySymbol = getSroiCurrencySymbol(countryOfOperation)

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('General Inputs')}</h3>

      <FieldLabelWrapper label={t('Report name')} labelFor={TITLE}>
        <Field placeholder={t('Report name')} formik={formik} name={TITLE} />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Country of Operation')} labelFor={COUNTRY_ID}>
        <CountryOfOperationField formik={formik} />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Investment')} labelFor={TOTAL_INVESTMENT}>
        <Field
          placeholder={t('Investment')}
          formik={formik}
          name={TOTAL_INVESTMENT}
          symbol={currencySymbol}
          type="number"
        />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Activity hours')} labelFor={TOTAL_ACTIVITY_HOURS}>
        <Field placeholder={t('Activity hours')} formik={formik} name={TOTAL_ACTIVITY_HOURS} type="number" />
      </FieldLabelWrapper>
    </section>
  )
}

export default GeneralInputsSection
